"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// allows to split by spaces not inclusing ones inside of brackers
var _default = /\s+(?![^(]*\))/g;
exports["default"] = _default;
//# sourceMappingURL=_splitbyspaceregexp.js.map